import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { secondary } = theme.palette;

  return {
    viewMedia: {
      color: secondary.dark,
      textTransform: "capitalize",
      fontSize: 11,
      padding: "0 8px",
      marginRight: -4,
      "&.Mui-disabled": {
        color: secondary.dark,
        opacity: 0.3
      },
      "&.details": {
        fontSize: 12,
        marginRight: -8
      }
    }
  };
});
